import _ from 'underscore';
import { TextAd } from '@bingads-webui-campaign/campaign-ui-schemas';

const displayUrlSeparator = ' | ';
const descriptionSeparator = ' - ';
const tokenisersWithSpaces = ['2e', '3f', '21'];
const tokenisersWithNoSpaces = [];

const longAdTitleDetails = _.pick(TextAd.properties.Title, 'AdTitleWithDescriptionMaxLimit', 'AdTitleWithDisplayUrlMaxLimit');

/*
<example>
  input  : displayUrl = https://www.bing.com
            title = Hotel
            details = {
              'AdTitleWithDisplayUrlMaxLimit'  : 62,
            }
  output : Hotel | bing.com
</example>
<example>
  input  : displayUrl = https://www.bing.com/search1/search2
            title = Hotel
            details = {
              'AdTitleWithDisplayUrlMaxLimit'  : 62,
            }
  output : Hotel | bing.com
</example>
*/
function generateTitleUsingDisplayUrl (displayUrl, title, details) {
  if (_.isEmpty(displayUrl.trim())) {
    return title;
  }

  let displayUrlInTitle = displayUrl.replace(/(http(s)*|ftp):\/\//i, '');

  const firstSlashIndex = displayUrlInTitle.indexOf('/');

  if (firstSlashIndex !== -1) {
    displayUrlInTitle = displayUrlInTitle.substring(0, firstSlashIndex);
  }

  if (displayUrlInTitle.substring(0, 4) === 'www.') {
    displayUrlInTitle = displayUrlInTitle.substring(4);
  }

  if (title && title.indexOf(displayUrlInTitle) > -1) {
    return title;
  }

  const newTitle = title + displayUrlSeparator + displayUrlInTitle;

  if (details && newTitle.length > details.AdTitleWithDisplayUrlMaxLimit) {
    return title;
  }

  return newTitle;
}

/*
<example>
  @input : description = This is a great hotel. I like it.
            title = Hotel
            details = {
            'AdTitleWithDescriptionMaxLimit' : 62
            }
  @output: description = I like it.
            title = Hotel - This is a great hotel.
            isLongAdTitle = true
</example>
<example>
  @input : description = This is a great hotel.
            title = Hotel
            details = {
            'AdTitleWithDescriptionMaxLimit' : 62
            }
  @output: description = This is a great hotel.
            title = Hotel
            isLongAdTitle = false
</example>
*/
function generateTitleUsingDescription(description, title, details) {
  let isLongAdTitle = false;
  let resultDescription = description;
  let resultTitle = title;

  if (!_.isEmpty(details)) {
    const maxLimit = details.AdTitleWithDescriptionMaxLimit;
    const originalLength = description.length;
    const inputChars = description.split('');
    const startPosition = originalLength - 1;

    for (let i = startPosition; i > 0; i--) {
      const character = description.charCodeAt(i).toString(16);

      if (_.contains(tokenisersWithNoSpaces, character) || (_.contains(tokenisersWithSpaces, character) && (i === startPosition || inputChars[i + 1] === ' '))) {
        const extendedTitle = description.substring(0, i + 1);
        const newTitle = title + descriptionSeparator + extendedTitle;

        if (newTitle.length < maxLimit) {
          resultDescription = description.substring(i + 1);
          resultTitle = newTitle;
          isLongAdTitle = true;
          break;
        }
      }
    }
  }

  return {
    title: resultTitle,
    description: resultDescription,
    isLongAdTitle,
  };
}

export default {
  generate(description, displayUrl, title) {
    const results = generateTitleUsingDescription(description, title, longAdTitleDetails);

    if (results.isLongAdTitle) {
      return {
        title: results.title,
        description: results.description,
      };
    } else {
      return {
        title: generateTitleUsingDisplayUrl(displayUrl, title, longAdTitleDetails),
        description,
      };
    }
  },
};
